import { render, staticRenderFns } from "./ScoutCandidate.vue?vue&type=template&id=3ad39feb"
import script from "./ScoutCandidate.vue?vue&type=script&lang=js"
export * from "./ScoutCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports